/** @format */

import styled from 'styled-components';

export const FormControl = styled.div<{ $filled: boolean; $variant: 'light' | 'dark'; $type?: string }>`
  width: 100%;
  --accent-color: ${({ theme }) => theme.color.teal.light};

  & > * {
    display: block;
  }

  ${({ $type }) =>
    $type === 'radio' || $type === 'checkbox'
      ? `
      display: flex;
    align-items: center;
    gap: 0.5rem;`
      : `
  display: grid;
  position: relative;
  `}

  label,
  input,
  select {
    color: ${({ theme }) => theme.color.teal.dark};
    font-size: ${({ theme }) => theme.font.size[0.9375]};
  }

  input,
  select {
    width: 100%;
  }

  input,
  select,
  textarea {
    font-family: ${({ theme }) => theme.font.body};
    border-radius: 0.65rem;
    border: 1px solid ${({ theme }) => theme.color.teal.dark};
    padding: 0.75rem 0.94rem;
    background-color: ${({ theme }) => theme.color.white};

    &:focus,
    &:active {
      outline: 2px solid
        ${({ $variant, theme }) => ($variant === 'light' ? 'var(--accent-color)' : theme.color.teal.dark)};
    }
  }
  input:not(.react-select__input),
  select {
    max-height: 44px;
    min-height: 44px;
  }

  input[type='checkbox'] {
    max-height: 24px;
    min-height: 24px;
    min-width: 24px;
  }

  select ~ label {
  }

  label {
    span {
      font-size: 0.75rem;
    }
    z-index: 1;
    --filled-transform: translateY(-100%);
    --filled-font-size: ${({ theme }) => theme.font.size['0.6875']};
    --filled-background: ${({ theme }) => theme.color.white};
    --filled-padding-inline: 0.25rem;

    color: ${({ theme }) => theme.color.teal.dark};
    font-family: ${({ theme }) => theme.font.title};
    display: inline-block;
    transition: all 0.3s ease-in-out;
    pointer-events: none;
    color: ${({ theme, $variant }) => ($variant === 'light' ? theme.color.teal.dark : theme.color.white)};
    margin-bottom: 0.375rem;
  }

  input[type='file'] ~ label {
    transform: var(--filled-transform);
    font-size: var(--filled-font-size);
    background: ${({ theme }) => theme.color.white};
    color: ${({ theme }) => theme.color.teal.dark};
    padding-inline: var(--filled-padding-inline);
    text-transform: none;
    border-radius: ${({ $variant, theme }) => $variant !== 'light' && '0.32rem'};
  }

  .customReactSelect .react-select__control:active ~ label,
  .customReactSelect .react-select__control:focus ~ label,
  .customReactSelect .react-select__control:focus-within ~ label,
  .customReactSelect:focus-within ~ label,
  .customReactSelect .react-select__control:focus-visible ~ label,
  input:active ~ label,
  input:focus ~ label,
  input:focus-within ~ label,
  input:focus-visible ~ label,
  textarea:active ~ label,
  textarea:focus ~ label,
  textarea:focus-within ~ label,
  textarea:focus-visible ~ label,
  select:active ~ label,
  select:focus ~ label,
  select:focus-within ~ label,
  select:focus-visible ~ label,
  input[type='file']:active ~ label,
  input[type='file']:focus ~ label,
  input[type='file']:focus-within ~ label,
  input[type='file']:focus-visible ~ label {
    transform: var(--filled-transform);
    font-size: var(--filled-font-size);
    background: ${({ $variant, theme }) => ($variant === 'light' ? 'var(--filled-background)' : theme.color.teal.dark)};
    border-radius: ${({ $variant, theme }) => $variant !== 'light' && '0.32rem'};
    color: ${({ $variant, theme }) => ($variant !== 'light' ? theme.color.white : 'var(--accent-color)')};
    padding-inline: var(--filled-padding-inline);
    text-transform: none;
  }

  // #region AUTOFILL STYLES

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    border: 1px solid ${({ theme }) => theme.color.teal.dark};
    -webkit-text-fill-color: ${({ theme }) => theme.color.teal.dark};
    -webkit-box-shadow: 0 0 0px 1000px ${({ theme }) => theme.color.white} inset;
  }

  input.error,
  textarea.error,
  select.error {
    border: 1px solid #e56e69;
    outline-color: #e56e69 !important;
    color: #e56e69;
  }

  .customReactSelect.error ~ label,
  input.error ~ label,
  textarea.error ~ label,
  select.error ~ label {
    ${({ $filled, $variant, theme }) =>
      $filled ? ($variant === 'light' ? 'background: var(--filled-background);' : `background: #e56e69;`) : ''}
    color: ${({ $filled, $variant, theme }) =>
      $filled
        ? $variant === 'light'
          ? 'background: var(--filled-background);'
          : `color: ${theme.color.teal.dark};`
        : ''};
  }

  input.error:active ~ label,
  input.error:focus ~ label,
  input.error:focus-within ~ label,
  input.error:focus-visible ~ label,
  textarea.error:active ~ label,
  textarea.error:focus ~ label,
  textarea.error:focus-within ~ label,
  textarea.error:focus-visible ~ label,
  select.error:active ~ label,
  select.error:focus ~ label,
  select.error:focus-within ~ label,
  select.error:focus-visible ~ label {
    transform: var(--filled-transform);
    font-size: var(--filled-font-size);
    background: #e56e69;
    border-color: #e56e69;
    color: white;
    padding-inline: var(--filled-padding-inline);
    text-transform: none;
  }

  input {
    position: relative;
  }

  i {
    position: absolute;
    right: 0.94rem;
    top: 70%;
    transform: translateY(-50%);
  }

  // #endregion
`;
